"use client";

import { useState, useEffect } from "react";
import Icon from "@/components/ui/AppIcon";

const StickyContactButtons = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    const handleScroll = () => {
      setIsVisible(window.scrollY > 300);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!mounted || !isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col gap-3 lg:hidden">
      <a
        href="tel:+917890369000"
        className="w-14 h-14 bg-primary text-primary-foreground rounded-full shadow-lg flex items-center justify-center hover:bg-accent transition-all hover:scale-110"
        aria-label="Call Now"
      >
        <Icon name="PhoneIcon" size={24} />
      </a>
      <a
        href="https://wa.link/yurmqd"
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 bg-secondary text-secondary-foreground rounded-full shadow-lg flex items-center justify-center hover:bg-yellow-500 transition-all hover:scale-110"
        aria-label="WhatsApp"
      >
        <Icon name="ChatBubbleLeftRightIcon" size={24} />
      </a>
    </div>
  );
};

export default StickyContactButtons;